// EPS GLOBAL flag gating US-restricted data enforcement, read with
// `useGlobalFlag`. Mirrors the server switch read by UsRestrictedGuard and the
// US data interceptor: while off, US data checks are a no-op.
export const US_RESTRICTED_DATA_ENFORCEMENT_FLAG_KEY =
  'service.eps.us-restricted-data.enable-enforcement'
